import { useCallback, useMemo, useState } from 'react';
import { STAIR_INFO_OPTIONS, STAIR_HEIGHT_OPTIONS, SLOPE_OPTIONS, } from '@/constant/accessibility-options';
import { StairInfo, } from '@/generated-sources/openapi';
/**
 * Compute entrance form conditions from current values.
 * Pure function — no state, no side effects.
 */
export function getEntranceConditions(params) {
    return {
        showStairHeight: params.stairInfo === StairInfo.One,
        showDoorDirection: !params.isStandaloneBuilding,
    };
}
/**
 * Shared entrance form option constants.
 */
export const ENTRANCE_OPTIONS = {
    stairInfoOptions: STAIR_INFO_OPTIONS,
    stairHeightOptions: STAIR_HEIGHT_OPTIONS,
    slopeOptions: SLOPE_OPTIONS,
};
/**
 * Hook that manages entrance form state with auto-reset logic.
 *
 * Used in PlaceFormV2Screen and ReportCorrectionFormScreen to ensure
 * consistent state transitions (e.g. stairInfo !== ONE resets stairHeightLevel).
 */
export default function useEntranceFormLogic({ initialValues, isStandaloneBuilding, }) {
    const [stairInfo, setStairInfoState] = useState(initialValues === null || initialValues === void 0 ? void 0 : initialValues.stairInfo);
    const [stairHeightLevel, setStairHeightLevel] = useState(initialValues === null || initialValues === void 0 ? void 0 : initialValues.stairHeightLevel);
    const [hasSlope, setHasSlope] = useState(initialValues === null || initialValues === void 0 ? void 0 : initialValues.hasSlope);
    const [doorDirectionType, setDoorDirectionType] = useState(initialValues === null || initialValues === void 0 ? void 0 : initialValues.doorDirectionType);
    const [entranceDoorTypes, setEntranceDoorTypes] = useState(initialValues === null || initialValues === void 0 ? void 0 : initialValues.entranceDoorTypes);
    // When stairInfo changes away from ONE, auto-reset stairHeightLevel
    const setStairInfo = useCallback((value) => {
        setStairInfoState(value);
        if (value !== StairInfo.One) {
            setStairHeightLevel(undefined);
        }
    }, []);
    const conditions = useMemo(() => getEntranceConditions({ stairInfo, isStandaloneBuilding }), [stairInfo, isStandaloneBuilding]);
    return {
        // State
        stairInfo,
        stairHeightLevel,
        hasSlope,
        doorDirectionType,
        entranceDoorTypes,
        // Setters
        setStairInfo,
        setStairHeightLevel,
        setHasSlope,
        setDoorDirectionType,
        setEntranceDoorTypes,
        // Conditions
        conditions,
        // Options
        options: ENTRANCE_OPTIONS,
    };
}
